import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {StorageService} from '../../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ReportPrintService} from '../../../../Services/report-print.service';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';

@Component({
  selector: 'app-project-detail-report',
  templateUrl: './project-detail-report.component.html',
  styleUrls: [],
  standalone: false,
})
export class ProjectDetailReportComponent implements OnInit {

  @ViewChild('ReportOutput', {static: false}) ReportOutput: ElementRef;
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  rptName = 'Project Detail Report';
  isLoading = false;
  noDataFound = false;
  report: any = null;
  projects: any[] = [];
  users: any[] = [];
  reportDataToSendInEmail: EmailModel = new EmailModel();

  buttonConfig: any = {
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: false,
    close: true,
    clear: false,
    filters: false,
    reset: true,
  };

  filters: any = {
    project_id: '',
  };

  vm: any = {
    Preferences: [],
  };

  constructor(
    private titleService: Title,
    private router: Router,
    private tableDataService: DataService,
    private localStorage: StorageService,
    private notification: BsToastService,
    private reportPrint: ReportPrintService,
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle(this.rptName);
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));

    this.tableDataService.getApiListData('sys_user', '?pageNumber=0&pageSize=999').subscribe({
      next: (result: any) => {
        this.users = result.Data ?? result.items ?? [];
      },
    });

    this.tableDataService.getDataWithParams('project', 'pageNumber=0&pageSize=999').subscribe({
      next: (result: any) => {
        this.projects = Array.isArray(result) ? result : (result.Data ?? result.items ?? []);
      },
    });
  }

  getUserName(userId: string): string {
    if (!userId) {
      return '—';
    }
    const u = this.users.find(x => x.id === userId);
    return u ? u.name : userId;
  }

  resetFilters() {
    this.filters = {project_id: ''};
    this.report = null;
    this.vm.report = null;
  }

  close() {
    this.router.navigate(['/home']);
  }

  runReport() {
    if (!this.filters.project_id) {
      this.notification.showWarningToast('Please select a project.');
      return;
    }
    this.isLoading = true;
    this.noDataFound = false;
    this.report = null;

    this.tableDataService.getDataWithParams('ProjectDetailReport', 'project_id=' + this.filters.project_id).subscribe({
      next: (result: any) => {
        this.report = result ?? null;
        this.vm.report = this.report;
        this.noDataFound = !this.report;
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.notification.showErrorToast('Error loading report.');
        this.isLoading = false;
      },
    });
  }

  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.reportPrint.printInIframe(html);
    } catch (e) {
      console.error('Project Detail Report print failed', e);
    }
  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';
    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + this.rptName + '.<br><br>Best regards,<br><br>AcctXErp<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + this.rptName;
    try {
      this.cd.detectChanges();
    } catch {
    }
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      emailDocObj.pdfHtml = this.ReportOutput?.nativeElement?.outerHTML || '';
    }
    emailDocObj.activity_message = this.rptName;
    const now = new Date();
    emailDocObj.FileName = `ProjectDetailReport_${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}.pdf`;
    this.reportDataToSendInEmail = emailDocObj;
    const element = document.getElementById('sendEmailModal') as HTMLElement;
    if (element) {
      const emailModal = new Modal(element);
      emailModal.show();
    }
  }

  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.ReportOutput?.nativeElement?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const meta: { label: string; value: string }[] = [];
    if (this.report?.name) {
      meta.push({label: 'Project', value: this.report.name});
    }
    return this.reportPrint.buildHtml({title: this.rptName, contentHtml: content, meta, orientation: 'portrait'});
  }
}
